export default "__VITE_ASSET__doUxB$a___"